export default {
  setCurrentaAnalyticsDashboard(state, payload) {
    state.current_analytics_dashboard = payload
  }
}
